module.exports = __webpack_public_path__ + "img/step5.05297ce1.svg";